import React, { useState, useEffect } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { isIOS } from '../utils/platformDetect';
import { isSessionDismissed, setSessionDismissed, trackEvent } from '../utils/promoTracking';
import { useLanguage } from '../contexts/LanguageContext';
import { APP_STORE_URL } from '../utils/platformDetect';
import './SmartAppBanner.css';

function SmartAppBanner() {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    // Only show on iOS and if not dismissed this session
    if (!isIOS() || isSessionDismissed('smart_banner')) return;

    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    setSessionDismissed('smart_banner');
    trackEvent('smart-banner-dismiss');
  };

  const handleClick = () => {
    trackEvent('smart-banner-click');
    window.open(APP_STORE_URL, '_blank', 'noopener');
  };

  if (!visible) return null;

  return (
    <div className="smart-app-banner" role="banner" aria-label={t('appName')}>
      <button
        className="smart-banner-close"
        onClick={handleDismiss}
        aria-label="Close"
      >
        <IoCloseOutline size={20} />
      </button>
      <div className="smart-banner-icon">
        <img src="/logo192.png" alt={t('appName')} width="40" height="40" />
      </div>
      <div className="smart-banner-info">
        <span className="smart-banner-title">{t('appName')}</span>
        <span className="smart-banner-subtitle">{t('appTagline')}</span>
      </div>
      <button className="smart-banner-cta" onClick={handleClick}>
        {t('viewInAppStore')}
      </button>
    </div>
  );
}

export default SmartAppBanner;
